import React, { Component } from 'react'

import PowerProjectTable from '../Tables/PowerProjectTable'
import DownloadDataLink from '../Tables/DownloadDataLink'

class Home extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filter: null
    }
    this.applyFilter = this.applyFilter.bind(this)
  }

  applyFilter (filter) {
    this.setState({ filter })
  }

  render () {
    const powerProjects = this.props.data.powerProjects
      ? Object.values(this.props.data.powerProjects)
      : []

    const id = 'power-projects'

    return (
      <div>
        <div className='row'>
          <div className='col'>
            <h1>Power projects</h1>
            <DownloadDataLink forId={id} filename={id} />
          </div>
        </div>
        <PowerProjectTable id={id} powerProjects={powerProjects} />
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/App/PowerProjects.js